module.exports = __webpack_public_path__ + "static/img/team-build-02.2dd4515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/team-build-02.jpg
// module id = faBF
// module chunks = 1